module.exports = __webpack_public_path__ + "img/37.7c2a8273.png";